module.exports = __webpack_public_path__ + "img/google.e495339.svg";